import { genres, movieCatalog } from '@/mocks/movies';
import type { Movie } from '@/pages/home/types';

interface GenreOverviewProps {
  onPickGenre: (genre: string) => void;
}

const genreIcons: Record<string, string> = {
  动作: 'ri-flashlight-line',
  科幻: 'ri-planet-line',
  悬疑: 'ri-eye-line',
  剧情: 'ri-film-line',
  爱情: 'ri-heart-line',
  喜剧: 'ri-emotion-laugh-line',
  奇幻: 'ri-magic-line',
  动画: 'ri-brush-line',
  战争: 'ri-sword-line',
  冒险: 'ri-compass-3-line',
};

export default function GenreOverview({ onPickGenre }: GenreOverviewProps) {
  const genresWithCount = genres
    .filter((g) => g !== '全部')
    .map((g) => ({
      name: g,
      icon: genreIcons[g] || 'ri-apps-2-line',
      count: (movieCatalog as Movie[]).filter((m) => m.genre === g).length,
    }));

  return (
    <section id="genres" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex flex-col gap-3">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-layout-grid-line"></i>
              类型速览
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              按类型进入电影大全
            </h2>
            <p className="max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              如果你还没想好具体看哪部，可以先从类型入手。每个类型都标注了当前片库中的内容数量，点一下即可跳到片库并自动完成筛选。
            </p>
          </div>
          <a
            href="#library"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览完整片库
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {genresWithCount.map((g) => (
            <button
              key={g.name}
              type="button"
              onClick={() => onPickGenre(g.name)}
              className="group flex cursor-pointer flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4 text-left transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${g.icon} text-xl`}></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">{g.name}</span>
              <span className="text-xs text-foreground-500">{g.count} 部内容</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}